function setOrders(state, orders) {
	if (!orders || !orders.length) return;
	state.orders = orders;
}

export default {
	setOrders,
};
